import { call, put } from "redux-saga/effects";
import { tenantService } from "../services/tenantService";
import { tenantConstants } from "../actions/constants/tenantConstants";
import { commonConstants } from "../actions/constants/commonConstants";

function* getTenantList(action: any): any {
  try {
    const response = yield call(tenantService.getTenantList, action.payload);
    if (response.success) {
      yield put({ type: tenantConstants.getTenantListSuccess, payload: response.resultObject });
    } else {
      yield put({ type: tenantConstants.getTenantListFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: tenantConstants.getTenantListFailure, payload: error });
  }
}

function* getHeaderTenantList(action: any): any {
  try {
    const response = yield call(tenantService.getTenantList, action.payload);
    if (response.success) {
      yield put({ type: tenantConstants.getHeaderTenantListSuccess, payload: response.resultObject });
    } else {
      yield put({ type: tenantConstants.getHeaderTenantListFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: tenantConstants.getHeaderTenantListFailure, payload: error });
  }
}

function* saveTenant(action: any): any {
  try {
    const response = yield call(tenantService.saveTenant, action.payload);
    if (response.success) {
      yield put({ type: tenantConstants.tenantSaveSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: tenantConstants.tenantSaveFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: tenantConstants.tenantSaveFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* viewTenant(action: any): any {
  try {
    const response = yield call(tenantService.viewTenant, action.payload.id);
    if (response.success) {
      yield put({ type: tenantConstants.tenantViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: tenantConstants.tenantViewFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: tenantConstants.tenantViewFailure, payload: error });
  }
}

function* getAccessControl(action: any): any {
  try {
    const response = yield call(tenantService.getAccessControl, action.payload);
    if (response.success) {
      yield put({ type: tenantConstants.getAccessControlSuccess, payload: response.resultObject?.data });
    } else {
      // 404 is fine - no access control configured yet
      yield put({ type: tenantConstants.getAccessControlSuccess, payload: null });
    }
  } catch (error) {
    yield put({ type: tenantConstants.getAccessControlSuccess, payload: null });
  }
}

function* saveAccessControl(action: any): any {
  try {
    const response = yield call(tenantService.saveAccessControl, action.payload);
    if (response.success) {
      yield put({ type: tenantConstants.saveAccessControlSuccess, payload: response.resultObject?.data });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: tenantConstants.saveAccessControlFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: tenantConstants.saveAccessControlFailure, payload: error });
  }
}

export const tenantSaga = {
  getTenantList,
  getHeaderTenantList,
  saveTenant,
  viewTenant,
  getAccessControl,
  saveAccessControl,
};
